import { Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import Callout from 'modules/core/components/Callout'
import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { formatDateRangeCopy } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/lib/getDateRange'
import MinutesToText from 'modules/attendance/components/MinutesToText'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'
import { useTimesheetData } from 'modules/attendance/lib/timesheetDataContext'
import { TimesheetFeatures } from 'modules/attendance/lib/timesheetFeatures'

interface Props {
  timeSheetData: ReturnType<typeof useTimesheetData>
}

const Overview = ({ timeSheetData }: Props) => {
  const { lastCycle, openPeriod, bankOfHours, featureByName } = timeSheetData
  const { stringDateFrom, dateToOrToday } = useAttendanceDateNavigator()
  const startOnStr = lastCycle ? lastCycle.startDate : stringDateFrom

  const hasBankOfHours = TimesheetFeatures.BANK_OF_HOURS in featureByName
  const hasBankOfHoursV2 = TimesheetFeatures.BANK_OF_HOURS_V2 in featureByName
  const shouldUseBankOfHoursV2Flow = hasBankOfHours && hasBankOfHoursV2

  const cycleEndOn = lastCycle ? moment(lastCycle.endDate) : moment(dateToOrToday)
  const todayBackend = i18nDateToString(new Date(), 'backend')
  const todayMoment = moment(todayBackend, 'YYYY-MM-DD')
  const endOn = shouldUseBankOfHoursV2Flow
    ? todayMoment.clone().subtract(1, 'day')
    : cycleEndOn.isSame(todayMoment, 'day')
    ? cycleEndOn.clone().subtract(1, 'day')
    : cycleEndOn
  const endOnStr = i18nDateToString(endOn.toDate(), 'backend')

  const todayIsLastCycleStart = todayBackend === lastCycle?.startDate
  const showCycleStartsTodayMessage = todayIsLastCycleStart
  const cycleRangeCopy = shouldUseBankOfHoursV2Flow
    ? formatDateRangeCopy(startOnStr, endOnStr)
    : formatDateRangeCopy(startOnStr, endOnStr)

  return (
    <>
      <Box flexDirection="row" gap="s2">
        {showCycleStartsTodayMessage ? (
          <Text size="200">{i18n.t('clock_in.bank_of_hours.sidepanel.cycle_starts_today')}</Text>
        ) : (
          <>
            <Text size="200" weight="medium">
              {`${i18n.t('clock_in.bank_of_hours.sidepanel.cycle')}:`}
            </Text>
            <Text size="200" weight="medium">
              {cycleRangeCopy}
            </Text>
          </>
        )}
      </Box>

      {!openPeriod && !shouldUseBankOfHoursV2Flow && (
        <Callout
          description={i18n.t('clock_in.bank_of_hours.sidepanel.closed_period_warning')}
          type="warning"
        />
      )}

      <Box gap="s4">
        <Box flexDirection="row" alignItems="center" gap="s2">
          <MinutesToText value={bankOfHours} size="500" weight="medium" color="grey1000" />
          {shouldUseBankOfHoursV2Flow && !showCycleStartsTodayMessage && (
            <>
              <Text size="200" weight="medium" color="grey600">
                ·
              </Text>
              <Text size="200" weight="medium" color="grey600">
                {i18n.t('clock_in.bank_of_hours.counters.as_of_yesterday')}
              </Text>
            </>
          )}
        </Box>

        <Text size="200">{i18n.t('clock_in.bank_of_hours.sidepanel.description')}</Text>
      </Box>
    </>
  )
}

export default Overview
